(function () {
  'use strict';

  angular.module('app').component('planDetail', planDetail());

  function planDetail() {
    return {
      bindings: {
        item: '=',
        mode: '<',
        onSavedItem: '&',
        onCanceledItem: '&',
        additionalLanguages: '<',
      },
      controller: PlanDetailCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/admin/plans/plan-detail/plan-detail.component.html',
    };
  }

  PlanDetailCtrl.$inject = [
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'PlanService',
    'FeatureService',
    'AddonService',
    'LanguageService',
  ];

  function PlanDetailCtrl(
    config,
    $translate,
    $filter,
    UtilService,
    PlanService,
    FeatureService,
    AddonService,
    LanguageService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    $translate = $filter('translate');

    vm.billingFrequencyOptions = config.BILLING_FREQUENCY_OPTIONS;
    vm.freeTrialOptions = config.FREE_TRIAL_OPTIONS;

    vm.selectedPlanFeature = {};
    vm.originalSelectedPlanAddons = [];

    // Methods
    vm.addPricingModel = addPricingModel;
    vm.removePricingModel = removePricingModel;
    vm.validateUniquePricingModels = validateUniquePricingModels;

    vm.validateFeatureQuantity = validateFeatureQuantity;

    vm.openAddonsModal = openAddonsModal;
    vm.groupAddonsByFeature = groupAddonsByFeature;
    vm.addAddon = addAddon;
    vm.removeAddon = removeAddon;
    vm.selectAddon = selectAddon;
    vm.changeAddonStatus = changeAddonStatus;

    vm.openTranslations = openTranslations;
    vm.editPlan = editPlan;
    vm.cancelEdit = cancelEdit;
    vm.savePlan = savePlan;
    vm.cancel = cancel;

    vm.$onInit = function () {
      if (vm.item.id) {
        // Edit
        setItemOptions(vm.item, vm.mode);
      } else {
        // New
        vm.createMode = true;

        vm.item = {
          name: '',
          pricing_model: [
            {
              billing_time: 1,
            },
          ],
          trial_period: {
            total_time: '', //0
            time_unit: '',
          },
          addons: [],
        };

        vm.itemName = 'NEW_PLAN';
      }

      // Initializers
      getAdditionalLanguages();
      getFeatureOptions();
      getAddons();
    };

    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        vm.editMode = true;

        editPlan();
      }

      loadSelectedPlanFeatures(vm.item.plan_features);

      vm.originalItem = angular.copy(item); // store server data

      vm.flashMessage = vm.UtilService._displayFlashMessage();

      vm.itemName = vm.item.name;
    }

    function editPlan() {
      vm.editMode = true;
      vm.viewMode = false;
    }

    function cancelEdit() {
      vm.item = vm.originalItem;
      setItemOptions(vm.item);
    }

    function getAdditionalLanguages() {
      vm.additionalLanguages = {};
      LanguageService.getLanguages({ get: 'translations', skip_check_role: true }).then(function (
        data
      ) {
        vm.additionalLanguages = data.items;
      });
    }

    function getFeatureOptions() {
      vm.featureOptions = null;
      FeatureService.getFeatures().then(function (data) {
        vm.featureOptions = FeatureService.groupFeaturesByCategory(data.items);
      });
    }

    function getAddons() {
      AddonService.getAddons({ get: 'active', skip_check_role: true }).then(function (data) {
        vm.addonOptions = data.items;

        if (!vm.createMode) {
          // Edit
          loadSelectedPlanAddons(vm.item.plan_addons, vm.addonOptions);
        }
      });
    }

    function openAddonsModal() {
      AddonService.openAddonsModal(getAddons);
    }

    function addPricingModel() {
      vm.item.pricing_model.push({});
      validateUniquePricingModels();
    }

    function removePricingModel(index) {
      vm.item.pricing_model.splice(index, 1);
      validateUniquePricingModels();
    }

    // Avoid duplicate pricing models
    function validateUniquePricingModels() {
      vm.pricingModelsDuplicated = false;

      var pricingModel = vm.item.pricing_model;
      if (pricingModel.length > 1) {
        for (var i = 0; i < pricingModel.length; ++i) {
          for (var j = 0; j < pricingModel.length; ++j) {
            pricingModel[j].duplicatedPrice = false;
            if (
              i !== j &&
              ((pricingModel[i].billing_time &&
                pricingModel[i].billing_time === pricingModel[j].billing_time &&
                pricingModel[i].time_unit === pricingModel[j].time_unit) ||
                (pricingModel[i].price && pricingModel[i].price === pricingModel[j].price))
            ) {
              if (pricingModel[i].price === pricingModel[j].price) {
                pricingModel[j].duplicatedPrice = true;
              }

              vm.pricingModelsDuplicated = true;
              return false;
            }
          }
        }
        return true;
      }
    }

    // Avoid feature quantity - TODO: willy - Adjust for future features
    function validateFeatureQuantity(featureSelected) {
      if (
        featureSelected.name_key &&
        featureSelected.type === 'quantity' &&
        (featureSelected.name_key === 'company' || featureSelected.name_key === 'website')
      ) {
        vm.errorFeatureQuantity = false;
        var companyValue, websiteValue;

        if (!vm.editMode) {
          // create
          for (var key in vm.featureOptions) {
            if (vm.featureOptions.hasOwnProperty(key)) {
              var features = vm.featureOptions[key].features;

              features.forEach(function (feature) {
                if (feature.name_key === 'company') {
                  companyValue = feature.value;
                } else if (feature.name_key === 'website') {
                  websiteValue = feature.value;
                }
              });
            }
          }
        } else {
          var featureOptions = FeatureService.setFeaturesSelected(
            'edit',
            vm.featureOptions,
            'feature_id',
            vm.selectedPlanFeature
          );
          for (var keyB in featureOptions) {
            if (featureOptions.hasOwnProperty(keyB)) {
              var feature = featureOptions[keyB];

              if (feature.name_key === 'company') {
                companyValue = feature.total_units;
              } else if (feature.name_key === 'website') {
                websiteValue = feature.total_units;
              }
            }
          }
        }

        if (companyValue > websiteValue) {
          vm.errorFeatureQuantity = true;
          return false;
        }

        return true;
      }
    }

    function groupAddonsByFeature(item) {
      if (item.id) {
        return item.feature.name;
      }
    }

    function addAddon() {
      vm.item.addons.push({ new: true, status: true });
      validateUniquePlanAddons();
    }

    function removeAddon(index) {
      vm.item.addons.splice(index, 1);
      validateUniquePlanAddons();
    }

    function selectAddon(addon, item) {
      addon.name = item.name;
      addon.total_units = 1;
      addon.unit_price = item.unit_price;
      addon.status = true;
      addon.addon_id = item.id;

      validateUniquePlanAddons();
    }

    // Avoid duplicate plan addons
    function validateUniquePlanAddons() {
      vm.planAddonsDuplicated = vm.UtilService.validateUniqueItems(vm.item.addons, 'addon_id');
    }

    function changeAddonStatus(addon) {
      addon.status = !addon.status;
    }

    // Append only the new feature not found in plan features
    function resetFeatureOptionsValueInput() {
      for (var key in vm.featureOptions) {
        if (vm.featureOptions.hasOwnProperty(key)) {
          var features = vm.featureOptions[key].features;

          features.forEach(function (feature) {
            var value = (feature.value = feature.type === 'quantity' ? 1 : false);

            if (vm.selectedPlanFeature[feature.id] === undefined) {
              vm.selectedPlanFeature[feature.id] = { value: value };
            }
          });
        }
      }
    }

    function loadSelectedPlanFeatures(planFeatures) {
      planFeatures.forEach(function (planFeature) {
        var type, value;

        if (planFeature.total_units != null) {
          type = 'quantity';
          value = planFeature.total_units;
        } else {
          type = 'available';
          value = planFeature.available;
        }

        var option = {
          id: planFeature.id,
          type: type,
          name_key: planFeature.feature ? planFeature.feature.name_key : '',
          value: value,
          feature_id: planFeature.feature_id,
        };

        vm.selectedPlanFeature[planFeature.feature_id] = option;
      });

      resetFeatureOptionsValueInput();
    }

    function loadSelectedPlanAddons(planAddons, addonOptions) {
      vm.item.addons = [];

      function appendToAddons(planAddon) {
        var option = {
          id: planAddon.id,
          name: planAddon.addon.name,
          total_units: planAddon.total_units,
          unit_price: planAddon.unit_price,
          status: planAddon.status,
          addon_id: planAddon.addon_id,
        };

        vm.item.addons.push(option);
      }

      if (addonOptions.length > 0) {
        planAddons.forEach(function (planAddon) {
          for (var i = 0; i < addonOptions.length; i++) {
            var addon = addonOptions[i];

            if (planAddon.addon_id === addon.id) {
              // Addon exists
              appendToAddons(planAddon);
              break;
            }
          }
        });
      } else {
        planAddons.forEach(function (planAddon) {
          appendToAddons(planAddon);
        });
      }

      vm.originalSelectedPlanAddons = angular.copy(vm.item.addons);
    }

    function openTranslations() {
      PlanService.openPlanTranslations(vm.item, vm.additionalLanguages);
    }

    function removePlanAddons(addonsSelected) {
      // Loop original plan addons
      vm.originalSelectedPlanAddons.forEach(function (planAddon) {
        var planAddonFound = false;
        for (var i = 0; i < addonsSelected.length; i++) {
          var planAddonId = addonsSelected[i].id;

          if (planAddon.id === planAddonId) {
            planAddonFound = true;
            break;
          }
        }

        // Remove unselected and planAddons
        if (planAddonFound === false) {
          PlanService.removePlanAddon(vm.item.id, planAddon.id);
        }
      });
    }

    // Create/Update
    function savePlan(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        vm.UtilService.scrollToTop();

        return;
      }

      var option = !vm.editMode ? 'create' : 'edit';
      var featuresSelected = FeatureService.setFeaturesSelected(
        option,
        vm.featureOptions,
        'feature_id',
        vm.selectedPlanFeature
      ); //'feature_id',
      var addonsSelected = AddonService.setAddonsSelected(vm.item.addons, 'addon_id');

      // Remove plan addons if unselected from original
      removePlanAddons(addonsSelected);

      vm.item.plan_features = featuresSelected;
      vm.item.plan_addons = addonsSelected;

      vm.sendingForm = true;
      PlanService.savePlan(vm.item).then(function (data) {
        var status = data.status;
        var response = data.response;

        if (status) {
          // Success
          if (!vm.editMode) {
            // Create
            vm.onSavedItem({ item: response });
          } else {
            // Edit
            vm.item = response;
            setItemOptions(response);

            // console.log(response);

            //vm.originalSelectedPlanAddons = angular.copy(response.plan_addons);
            loadSelectedPlanAddons(response.plan_addons, vm.addonOptions);

            vm.flashMessage = vm.UtilService._clearFlashMessage();
          }
        } else {
          vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);

          vm.formErrors = true;
        }

        vm.UtilService.scrollToTop();

        vm.sendingForm = false;
      });
    }

    function cancel() {
      /*if (vm.editMode){
                vm.cancelEdit();
                return;
            }*/

      vm.onCanceledItem();
    }
  }
})();
